// Файл: frontend/src/context/AuthContext.js (ФИНАЛЬНАЯ ВЕРСИЯ)

import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { getProfile } from '../api/apiService';

const AuthContext = createContext();
const normalizeUser = value => value && (value._id || value.id) ? { ...value, _id: String(value._id || value.id) } : value;

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  // --- НАЧАЛЬНОЕ СОСТОЯНИЕ ТЕПЕРЬ БОЛЕЕ УМНОЕ ---
  // TODO: Переписать на куки.
  const [user, setUser] = useState(() => {
    // Мы считаем пользователя залогиненным, только если есть и токен, и данные
    const savedToken = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    try { return savedToken && savedUser ? normalizeUser(JSON.parse(savedUser)) : null; } catch { return null; }
  });

  const [token, setToken] = useState(() => localStorage.getItem('token') || null);

  // Этот useEffect будет следить за изменениями и синхронизировать localStorage
  useEffect(() => {
    if (token && user) {
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('token', token);
    } else {
      // Если чего-то одного нет, очищаем все
      localStorage.removeItem('user');
      localStorage.removeItem('token');
    }
  }, [user, token]);

  const login = (userData, userToken) => {
    setUser(normalizeUser(userData));
    setToken(userToken);
  };

  const updateUser = useCallback(
    (patch) => setUser((prev) => (prev ? normalizeUser({ ...prev, ...patch }) : prev)),
    []
  );

  // Сохранённый в браузере пользователь может быть устаревшим: токен живёт 7 дней,
  // а до 25.09.2026 вход не отдавал аватар. Один раз при открытии сайта
  // подтягиваем актуальные имя, email и аватар.
  useEffect(() => {
    if (!token) return undefined;
    let cancelled = false;
    getProfile()
      .then((res) => {
        if (cancelled || !res?.data) return;
        const { name, email, avatarUrl, role, allowedReps } = res.data;
        updateUser({ name, email, avatarUrl: avatarUrl || null, ...(role ? { role, allowedReps: allowedReps || [] } : {}) });
      })
      .catch(() => { /* нет сети — оставляем сохранённого пользователя */ });
    return () => { cancelled = true; };
  }, [token, updateUser]);

  const logout = () => {
    setUser(null);
    setToken(null);
  };

  const value = {
    user,
    token,
    login,
    logout,
    updateUser,
    isAuthenticated: !!user && !!token // <-- Проверка стала строже
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
